import { Container } from 'src/components/common/Container'
import { Typography } from 'src/components/common/Typography'
import useDynamicWidth from 'src/hooks/useDynamicWidth.hook'
import { PreviewPageProps } from 'src/pages/PreviewPage'
import {
  Noto_body1_b16,
  Noto_body1_m16,
  Noto_body2_b14,
  Noto_body2_m14,
  Noto_body2_r14,
  Noto_heading3_b20,
  Noto_subheading_b18,
} from 'src/styles/fonts/NotoSansKrFonts'
import { Roboto_num4_b12 } from 'src/styles/fonts/RobotoFonts'
import { mediaMaxWidth } from 'src/styles/mixin'
import { click_tracking_dataLayer } from 'src/utils/gtmDataLayer'
import styled from 'styled-components'

const PreviewAlwaysDiscount = (props: PreviewPageProps) => {
  const { alwaysDiscountCategoryList, handleExternalOpenUrl } = props
  const { deviceWidth } = useDynamicWidth()
  const isMobile = deviceWidth <= 460

  const handleClickItem = (categoryNumber: number) => {
    click_tracking_dataLayer('mid_product')
    handleExternalOpenUrl(`always_${categoryNumber}`)
  }

  return (
    <S.PreviewAlwaysDiscountContainer>
      <S.Title.Container $option="flex_row" $column_gap="8px">
        <S.Title.Point $fontStyle={Roboto_num4_b12} $color="var(--white)">
          SALE
        </S.Title.Point>
        <S.Title.Text $fontStyle={Noto_subheading_b18} $color="var(--black-90)">
          매일 할인 중!
        </S.Title.Text>
      </S.Title.Container>
      <S.Description $fontStyle={Noto_body2_r14} $color="var(--black-50)">
        다양한 카테고리의 상시 할인 쿠폰
      </S.Description>
      <S.Category.Container>
        {alwaysDiscountCategoryList.map((category, index) => (
          <S.Category.Item
            key={index}
            $image={category.CategoryImage}
            onClick={() => handleClickItem(category.CategoryNumber)}
          >
            <Typography
              $fontStyle={isMobile ? Noto_subheading_b18 : Noto_heading3_b20}
              $color="var(--black-100)"
            >
              {category.CategoryName}
            </Typography>
            <S.Category.Price $option="flex_row" $column_gap="4px">
              <Typography
                $fontStyle={isMobile ? Noto_body2_b14 : Noto_body1_b16}
                $color="var(--brand-50)"
              >
                {category.LowestPrice.toLocaleString()}원
              </Typography>
              <Typography
                $fontStyle={isMobile ? Noto_body2_m14 : Noto_body1_m16}
                $color="var(--black-100)"
              >
                부터~
              </Typography>
            </S.Category.Price>
          </S.Category.Item>
        ))}
      </S.Category.Container>
    </S.PreviewAlwaysDiscountContainer>
  )
}

export default PreviewAlwaysDiscount

const S = {
  PreviewAlwaysDiscountContainer: styled(Container)`
    margin: 0 auto;
    padding: 0 20px;
    max-width: 460px;
    min-width: 320px;
  `,

  Title: {
    Container: styled(Container)`
      align-items: center;
      height: 32px;
    `,
    Text: styled(Typography)`
      line-height: unset;
    `,
    Point: styled(Typography)`
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      background: linear-gradient(180deg, #0083fc 0%, #6db9ff 100%);
      padding: 4px 6px;
      width: fit-content;
      height: 20px;
    `,
  },

  Description: styled(Typography)`
    display: flex;
  `,

  Category: {
    Container: styled(Container)`
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      gap: 10px;
      margin-top: 20px;
    `,
    Item: styled(Container)<{ $image: string }>`
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      padding: 0 13% 8%;
      width: 205px;
      aspect-ratio: 1 / 1;
      background: url(${({ $image }) => $image});
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
      border-radius: 12px;
      border: 1px solid #dfe9f2;
      cursor: pointer;

      ${mediaMaxWidth('460')} {
        width: 100%;
      }
    `,
    Price: styled(Container)`
      & span {
        letter-spacing: -1px;
        line-height: 20px;
      }
    `,
  },
}
